/*
 * Change the DOM to make the page look like a print preview
 * Doesn't handle popping up the print dialog, caller handles that
 *
 * Usage:

    import printPreviewModule from 'lib/printPreview';
    printPreviewModule.printPreview(function () {
        // Pop up browser print dialog.
        window.print();
    });
 */

import $ from 'jquery';

export function printPreview(callback) {
	// show print-only elements
	$('.onlyPrint, .onlyPrintInline').show();

	// remove screen-only elements from the window
	$('.noPrint').remove();

	window.setTimeout(function () {
		// an immediate setTimeout so above DOM manipulations are perceived
		callback();
	}, 25);
}

/**
 * Print a section of content by opening up a new window with that conent in it.
 * The popup closes after the user is done.
 *
 * @param {string} content - the stuff to print
 * @param {string} title - the title of the section to print
 */
export function printSectionInPopup(content, title) {
	let printPopup = window.open('', 'printPopup', 'left=80,top=0,width=630,height=615,scrollbars=yes');
	printPopup.document.write(content);
	printPopup.document.title = title;
	printPopup.document.close();
	printPopup.focus();
	printPopup.print();
	printPopup.close();
}



// WEBPACK FOOTER //
// ./lib/printPreview.es6